export enum ScheduleChangeStatus {
  ApproveManual = "APPROVE_MANUAL",
  ApproveNormal = "APPROVE_NORMAL",
  AlreadyApproved = "ALREADY_APPROVED",
  NotApproved = "NOT_APPROVED",
  None = "NONE",
}
